import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=cb5283d8&"
import script from "./CommentComponent.vue?vue&type=script&lang=js&"
export * from "./CommentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports